import { render, staticRenderFns } from "./ApplicationCategories.vue?vue&type=template&id=05c32e56&scoped=true"
import script from "./ApplicationCategories.vue?vue&type=script&lang=js"
export * from "./ApplicationCategories.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCategories.vue?vue&type=style&index=0&id=05c32e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c32e56",
  null
  
)

export default component.exports